module.exports = __webpack_public_path__ + "static/dominikawork7-5c9e35fee6644d16b076d558bc604834.jpg";